import { request } from '@api/request'
import { Bookmark as APIBookmark } from '@models/api/Bookmark'
import { AxiosResponse } from 'axios'
import { BookmarkFactory } from '@models/bookmark/BookmarkFactory'
import { BookmarkType } from '@models/bookmark/BookmarkFactory'

export const bookmarks = {
  getUserBookmarks: async function (): Promise<BookmarkType[]> {
    try {
      const result: AxiosResponse<APIBookmark[]> = await request.get(`bookmark`)
      const items = result.data.map((item) => {
        return BookmarkFactory.fromAPIBookmark(item)
      })
      return items.filter((x) => x !== undefined) as BookmarkType[]
    } catch (error) {
      return Promise.reject(error)
    }
  },

  putBookmark: function (bookmark: BookmarkType) {
    return request.put(
      `bookmark/${bookmark.id}`,
      APIBookmark.fromBookmark(bookmark)
    )
  },

  deleteBookmark: function (bookmark: BookmarkType) {
    return request.delete(`bookmark/${bookmark.id}`)
  }
}
